<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('profesionocupacion')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Datos de la actividad laboral del {{title}}
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>             
            <p align="justify">
              Profesión u Ocupación *
            </p>
            <div>            
              <md-field :class="getValidationClass('profesionocupacion')">
                <md-input type="text" id="nombreparticipetitular" name="paterno" placeholder="Su respuesta" v-model="form.profesionocupacion"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.profesionocupacion.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('tipoactividadnegocio')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Tipo de Actividad o Negocio *
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Rubro de la empresa en la que se encuentra trabajando.
            </p>              
            <div>            
              <md-field :class="getValidationClass('tipoactividadnegocio')">
                <md-input type="text" id="materno" name="materno" placeholder="Su respuesta" v-model="form.tipoactividadnegocio"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.tipoactividadnegocio.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombreempresa')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Nombre de la Empresa en donde trabaja *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('nombreempresa')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.nombreempresa"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombreempresa.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>  

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('cargo')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Cargo que ocupa en la Empresa *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('cargo')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.cargo"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.cargo.required">Esta respuesta es obligatoria.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                      
        
        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>  

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item6',
  props: ["title"],
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item6
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        profesionocupacion: {required,},
        tipoactividadnegocio: {required,},
        nombreempresa: {required,},
        cargo: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item6
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        
        this.$emit('setSaveForm', {id:"6", form: this.form, index: "7"}); 
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
